import styled from 'styled-components';
import Dialog from './Dialog';

import IconSpinner from '../../img/spinner.gif';
import IconCheck from '../../img/check.gif';
import IconFail from '../../img/ico_error.png';
import IconFail2X from '../../img/ico_error@2x.png';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { closeDialog } from '../../store/modules/dialog';
import { useDispatch } from 'react-redux';
import { usePOWebofficeSDKState } from '../../context/poWebOfficeSDKContext';
import { useDocInfoSliceSelector } from '../../store/modules/docInfo';
import { updateNaverWorksFile } from '../../extApis/naverWorksApi';
// import { useWhaleSpaceDataSliceSelector } from '../../store/modules/whaleSpaceData';
// import { requestUploadIttFile } from '../../extApis/whaleSpaceApi';
// import { QS_CONSTANT } from '../../define/global';
// import { getQSObject, getQSFromURL, getValueOfQSObject } from '../../utils/qsUtils';

const DialogBody = styled.div`
  display: flex;
  width: 332px;
  /* height: 398px; */
  flex-flow: column;
  justify-content: center;
  align-items: center;
`;

const DownloadStateIcon = styled.img`
  width: 64px;
  height: 64px;
`;

const DownloadComment = styled.p`
  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #2f3133;
  margin: 11px 0 32px 0;
`;

const initState = {
  INIT: 'init',
  COMPLETE: 'complete',
  FAIL: 'fail'
};

export default function UploadItt({ isShow }) {
  const [isComplete, setIsComplete] = useState(initState.INIT);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const poSDKContextState = usePOWebofficeSDKState();
  const docInfoSlice = useDocInfoSliceSelector();
  // const whaleSpaceSlice = useWhaleSpaceDataSliceSelector();
  const poSDKReady = poSDKContextState.poInstance !== null;

  // const query = getQSObject();
  // const queryUrl = decodeURIComponent(getValueOfQSObject(query, QS_CONSTANT.ITT_UPLOAD_URL.KEY));
  // const queryFromURL = queryUrl ? getQSFromURL(queryUrl) : undefined;
  // const qnttNo = queryFromURL
  //   ? getValueOfQSObject(queryFromURL, QS_CONSTANT.ITT_UPLOAD_NTTNO.KEY) || undefined
  //   : undefined;

  const upload = () => {
    if (poSDKReady) {
      poSDKContextState.poInstance.handle
        .saveDocument()
        .then((arg) => {
          const uploadFile = new File([arg.blob], docInfoSlice.fileName);
          return updateNaverWorksFile({ file: uploadFile, isLocal: true });
        })
        .then(() => {
          setIsComplete(initState.COMPLETE);
        })
        .catch((err) => {
          setIsComplete(initState.FAIL);
        });
    } else {
      setIsComplete(initState.FAIL);
    }
  };

  // const upload = () => {
  //   if (poSDKReady && qnttNo) {
  //     poSDKContextState.poInstance.handle
  //       .saveDocument()
  //       .then((arg) => {
  //         const uploadFile = new File([arg.blob], docInfoSlice.fileName);
  //         return requestUploadIttFile(uploadFile, qnttNo, whaleSpaceSlice.userEmail);
  //       })
  //       .then(() => {
  //         setIsComplete(initState.COMPLETE);
  //       })
  //       .catch((err) => {
  //         setIsComplete(initState.FAIL);
  //       });
  //   } else {
  //     setIsComplete(initState.FAIL);
  //   }
  // };

  useEffect(() => {
    upload();
  }, []);

  return (
    <Dialog
      title=""
      showCloseBtn={isComplete !== initState.INIT}
      showTitleSeperateLine={false}
      onClickCloseBtn={() => {
        dispatch(closeDialog());
      }}
      isShow={isShow}>
      <DialogBody>
        {isComplete === initState.INIT && (
          <>
            <DownloadStateIcon src={IconSpinner} />
            <DownloadComment>{t('Header.UploadingItt')}</DownloadComment>
          </>
        )}
        {isComplete === initState.COMPLETE && (
          <>
            <DownloadStateIcon src={IconCheck} />
            <DownloadComment>{t('Header.CompleteUploalItt')}</DownloadComment>
          </>
        )}
        {isComplete === initState.FAIL && (
          <>
            <DownloadStateIcon src={IconFail} srcSet={IconFail2X} />
            <DownloadComment>{t('Header.FailUploalItt')}</DownloadComment>
          </>
        )}
      </DialogBody>
    </Dialog>
  );
}
